import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconArrowTopBottom: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconArrowTopBottom"><Path d="M3.5 7.5L7.5 3.5L11.5 7.5" stroke="currentColor" strokeLinecap="square"/><Path d="M12.5 16.5L16.5 20.5L20.5 16.5" stroke="currentColor" strokeLinecap="square"/><Path d="M7.5 4V20.5" stroke="currentColor" strokeLinecap="square"/><Path d="M16.5 3.5V20" stroke="currentColor" strokeLinecap="square"/></CentralIconBase>;
});

export default IconArrowTopBottom;
